var darkBackgroundDict = {
  "default": ['notif_push_hi_primary', 'notif_push_hi_tertiary', 'background_surface_tertiary', 'campaign_better_primary', 'campaign_better_secondary', 'campaign_best_primary', 'campaign_black_week'],
  globe: ['background_surface_secondary', 'background_surface_tertiary']
};

// Set background color type to potentially invert text color
var isDarkBackground = function isDarkBackground(color, isGlobetrotter) {
  var darkBackgrounds = isGlobetrotter ? darkBackgroundDict.globe : darkBackgroundDict["default"];
  return darkBackgrounds.includes(color === null || color === void 0 ? void 0 : color.toLowerCase());
};
var convertJsToCssVar = function convertJsToCssVar(color) {
  return "var(--color-".concat(color === null || color === void 0 ? void 0 : color.toLowerCase().replace(/_/g, '-'), ")");
};

export { convertJsToCssVar, darkBackgroundDict, isDarkBackground };
//# sourceMappingURL=color.js.map
